export default __webpack_public_path__ + "static/media/img_about3.2e823a44.png";